export default class EventTarget
{
  constructor()
  {
    this.handlers = {};
  }
  addEventListener(eventtype, fn)
  {
    let eventhandlers = this.handlers[eventtype];
    if(!eventhandlers)
      eventhandlers = this.handlers[eventtype] = [];
    eventhandlers.push(fn);
  }
  removeEventListener(eventtype, fn)
  {
    let eventhandlers = this.handlers[eventtype];
    if(eventhandlers)
      eventhandlers = eventhandlers.filter(el => el!=fn);
  }
  dispatchEvent(event)
  {
    if(!('defaultPrevented' in event))
      throw new Error("Parmater passed is not an event");

    let eventhandlers = this.handlers[event.type];
    if(eventhandlers)
      eventhandlers.forEach(fn => fn.call(this, event));
    return event.defaultPrevented;
  }
}



// WEBPACK FOOTER //
// /opt/wh/whtree/~/dompack/extra/eventtarget.es